<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <div class="level">
        <div class="level-left">
          <h1 class="title is-5">{{ $t('announce.list') }}</h1>
        </div>
        <div class="level-right">
          <div class="field is-grouped controls">
            <div class="control" v-if="isAnnouncementManager">
              <button @click="goTo('createAnnouncement')"
                      class="button is-success">
                {{ $t('announce.create') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="level table-actions">
        <div class="level-left">
          <form @submit.prevent="onSearch">
            <div class="field is-grouped controls">
              <div class="control">
                <b-input v-model="q" :placeholder="$t('interface.search')"></b-input>
              </div>
              <div class="control mr-10">
                <button type="submit" class="button is-primary">
                  <b-icon icon="magnify" size="is-small"></b-icon>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="columns is-multiline mt-10">
        <div class="column is-6" v-for="item in list">
          <article class="message">
            <div class="message-body">
              <div class="mb-5 has-text-grey-light is-clearfix">
                <div class="is-pulled-left">
                  <small>{{item.created_at | localedDate}}</small>
                </div>
                <div class="is-pulled-right">
                  <b-dropdown position="is-bottom-left" class="burger-list" v-if="isAnnouncementManager">
                    <b-icon class="ml-5"
                            slot="trigger"
                            icon="dots-vertical"
                            size="is-small">
                    </b-icon>

                    <b-dropdown-item class="tdn" @click="remove(item.id)">
                      <b-icon icon="delete" size="is-small"></b-icon>
                      {{ $t('interface.remove') }}
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
              <h3 class="title is-6 mb-0">
                {{ item.name }}
              </h3>
              <p>{{ item.text }}</p>
            </div>
          </article>
        </div>
      </div>
      <b-pagination
          class="mt-15"
          @change="loadData"
          :total="total"
          :current.sync="page"
          :per-page="perPage">
      </b-pagination>
    </div>
  </DashboardLayout>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import DashboardLayout from '@/components/DashboardLayout'

  export default {
    components: {
      DashboardLayout
    },
    data() {
      return {
        loading: false,
        total: 0,
        page: 1,
        perPage: 15,
        q: ''
      }
    },
    methods: {
      loadData() {
        this.loading = true
        this.$store.dispatch('Announcement/getList', {
          page: this.page,
          page_size: this.perPage,
          q: this.q
        }).then((response) => {
          this.loading = false
          this.total = response.count
        }).catch((error) => {
          console.warn('ERROR:', error)
        })
      },
      onPageChange(page) {
        this.page = page
        this.loadData()
      },
      onSearch() {
        this.loadData()
      },
      resetFilters() {
        this.q = ''
        this.loadData()
      },
      goTo(route) {
        this.$router.push({name: route})
      },
      remove(announcementId) {
        this.$store.dispatch('Announcement/remove', announcementId)
      }
    },
    computed: {
      ...mapState('Announcement', ['list']),
      ...mapGetters('Account', ['isAnnouncementManager']),
      breadcrumbs() {
        return [
          {name: 'announcements'}
        ]
      }
    },
    mounted() {
      this.loadData()
    }
  }
</script>

<style lang="scss" scoped>
  .message {
    .message-body {
      padding: 8px 15px 20px;
      font-size: 14px;
    }

    .burger-list {
      color: #444;
      cursor: pointer;
    }

    &:hover .actions {
      opacity: 1;
    }

    p {
      margin-top: 5px;
    }
  }
</style>
